import React from 'react';
import Number from './Cell/Number';
import Chance from './Cell/Chance';
import Text from './Cell/Text';
import Module from './Cell/Module';
import Difficulty from './Cell/Difficulty';
import Document from './Cell/Document';
import Date from './Cell/Date';
import ComingSoon from './Cell/ComingSoon';
import { moduleTitle } from '@src/graphql/tables/TableFlexibleCell';
import { isArray } from 'lodash';
import DocumentList from './Cell/DocumentList';

const CellFactory = ({ cells }) => {
  if (!cells) return null;

  return cells?.map((block) => {
    switch (block.whatToShow) {
      case 'document':
        return isArray(block.document) ? (
          <DocumentList key={block.id} documents={block.document} />
        ) : (
          <Document key={block.id} block={{ document: block.document }} />
        );
      case 'coming_soon':
        return <ComingSoon />;
      case 'grade':
        return (
          <Number
            key={block.id}
            block={{
              value: block.grade,
              displayAs: 'grade',
            }}
          />
        );
      case 'percent':
        return (
          <Number
            key={block.id}
            block={{
              value: block.percent,
              displayAs: 'percent',
            }}
          />
        );
      case 'date':
        return <Date key={block.id} block={block} />;
      case 'video_explanation':
        return (
          <Text
            key={block.id}
            isVideoExplanation
            block={{
              body: block.videoExplanation,
            }}
          />
        );
      case 'likelihood':
        return (
          <Chance
            key={block.id}
            block={{
              text: block.likelihood,
            }}
          />
        );
      case 'module':
        return (
          <Module
            key={block.id}
            block={{
              text: moduleTitle(block.module),
              textClassName: block.module?.toLowerCase().split(' ').join('-'),
            }}
            style={{ textTransform: 'capitalize' }}
          />
        );
      case 'difficulty':
        return (
          <Difficulty
            key={block.id}
            block={{
              text: block.difficulty,
            }}
          />
        );
      default:
        console.log(`Couldn't find a block for ${block.__typename}`);
        return null;
    }
  });
};

export default CellFactory;
